import { render, staticRenderFns } from "./NoticesDetail.vue?vue&type=template&id=a639e3e8"
import script from "./NoticesDetail.vue?vue&type=script&lang=js"
export * from "./NoticesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a639e3e8')) {
      api.createRecord('a639e3e8', component.options)
    } else {
      api.reload('a639e3e8', component.options)
    }
    module.hot.accept("./NoticesDetail.vue?vue&type=template&id=a639e3e8", function () {
      api.rerender('a639e3e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/NoticesDetail.vue"
export default component.exports